module.exports = __webpack_public_path__ + "img/portrait-085.7cb5c90d.jpg";